import fetch from 'features/common/fetch';
import { FILTER_TYPE } from 'features/other/typeTasks/constants';
// eslint-disable-next-line import/no-cycle
import taskOverview from 'features/views/taskOverview';
import { getQuickFilterState } from 'features/views/taskOverview/selectors';

export const mapTasksToCard = (tasks, bigFilterOpen, quickFilterState, pageIds) => {
	const { QUICK_FILTER_STATES } = taskOverview.constants;

	return pageIds
		.map((id) => tasks[id])
		.filter((item) => {
			if (bigFilterOpen) return item;
			else if (quickFilterState === QUICK_FILTER_STATES.processed && item.processed) return item;
			else if (quickFilterState !== QUICK_FILTER_STATES.processed && !item.processed) return item;
			else return false;
		});
};

export const fetchStorePathUniqueRequestSuffixForTaskTypeId = (taskTypeId, state) => {
	const subheaderOpen = taskOverview.selectors.getSubheaderState(state);
	const filterType = subheaderOpen ? FILTER_TYPE.custom : FILTER_TYPE.quick;
	const quickFilterState = getQuickFilterState(state);
	return `${filterType}_${taskTypeId}_${quickFilterState}`;
};

export const fetchStorePathForTaskTypeId = (taskTypeId, state) => {
	const uniqueRequestSuffix = fetchStorePathUniqueRequestSuffixForTaskTypeId(taskTypeId, state);
	return `${fetch.constants.urls.taskList}.${uniqueRequestSuffix}`;
};
